import React from "react"
import PropTypes from "prop-types"
import LocationTreeShape from "../../../state/shapes/LocationTreeShape"
import Collapser from "./Collapser"
import styled from "styled-components"

const Branch = styled.li``

const ChildBranches = styled.ul``

const Leaf = styled.div``

const Checkbox = styled.input`
  display: visible;
`

/** A treeview style multiple choice location picker */
class Tree extends React.Component {
  static propTypes = {
    treeData: PropTypes.shape(LocationTreeShape).isRequired,
    checkedKeys: PropTypes.arrayOf(PropTypes.string),
    onUpdate: PropTypes.func.isRequired,
    searchText: PropTypes.string,
    flatData: PropTypes.array,
    isExpanded: PropTypes.bool,
    treeValue: PropTypes.string.isRequired,
    shouldRenderChildrenFn: PropTypes.func.isRequired,
    isSearchMatchFn: PropTypes.func.isRequired,
    childrenMatchSearchFn: PropTypes.func.isRequired,
    isTextSearchFn: PropTypes.func.isRequired,
    getChildValuesFn: PropTypes.func.isRequired
  }

  static defaultProps = {
    treeData: { children: [], value: "0" },
    checkedKeys: [],
    searchText: null,
    isExpanded: false
  }

  state = {
    isExpanded: false,
    checked: false
  }

  componentDidMount = () => {
    this.checkCheckedStatus(
      this.props.treeData.value,
      this.props.checkedKeys,
      this.props.isExpanded
    )
  }

  componentDidUpdate = prevProps => {
    if (
      prevProps.checkedKeys.length != this.props.checkedKeys.length ||
      prevProps.searchText.length != this.props.searchText.length
    ) {
      this.checkCheckedStatus(this.props.treeData.value, this.props.checkedKeys, this.state.isExpanded)
    }
  }

  checkCheckedStatus = (value, checkedKeys, isExpanded) => {
    if (this.props.isTextSearchFn() && !isExpanded) {
      var children = this.props.flatData.filter(d => d.parentValue == value)

      var childrenMatch = this.props.childrenMatchSearchFn(
        children,
        this.props.searchText,
        this.props.flatData
      )

      isExpanded = childrenMatch
    }

    this.setState({
      checked: checkedKeys.includes(value),
      isExpanded: isExpanded
    })
  }

  handleChange = event => {
    var value = event.target.value.toString()
    this.props.onUpdate(value)
  }

  handleExpandClick = () => {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const {
      treeData,
      flatData,
      checkedKeys,
      onUpdate,
      searchText,
      isTextSearchFn,
      isSearchMatchFn,
      shouldRenderChildrenFn,
      childrenMatchSearchFn,
      getChildValuesFn
    } = this.props

    const isTextSearch = isTextSearchFn()
    const isSearchMatch = isSearchMatchFn(treeData.label, searchText)
    const hasChildren = treeData.children && treeData.children.length > 0

    const renderChildren = shouldRenderChildrenFn(
      hasChildren,
      treeData.value,
      searchText,
      flatData,
      treeData.label
    )
    const showEmptyStateMessage = isTextSearch && !isSearchMatch && !renderChildren

    if (showEmptyStateMessage) {
      return null
    } else {
      return (
        <Branch>
          <div>
            <Leaf>
              {renderChildren && (
                <Collapser
                  isExpanded={this.state.isExpanded}
                  handleClick={this.handleExpandClick}
                  useLargerCheckbox={this.props.useLargerCheckbox}
                />
              )}{" "}
              <Checkbox
                className=""
                id={`location_${treeData.value}`}
                type="checkbox"
                value={treeData.value}
                onChange={this.handleChange}
                checked={this.state.checked}
              />
              <label htmlFor={`location_${treeData.value}`}>{treeData.label}</label>
            </Leaf>

            {renderChildren &&
              this.state.isExpanded && (
                <ChildBranches>
                  {treeData.children.map(d => {
                    let children = flatData.filter(f => f.parentValue == d.value)
                    if (
                      !isTextSearch ||
                      isSearchMatch ||
                      isSearchMatchFn(d.label, searchText) ||
                      childrenMatchSearchFn(children, searchText, flatData)
                    )
                      return (
                        <Tree
                          key={`key_${d.value}`}
                          treeValue={d.value}
                          treeData={d}
                          checkedKeys={checkedKeys}
                          onUpdate={onUpdate}
                          searchText={searchText}
                          flatData={flatData}
                          shouldRenderChildrenFn={shouldRenderChildrenFn}
                          isSearchMatchFn={isSearchMatchFn}
                          childrenMatchSearchFn={childrenMatchSearchFn}
                          isTextSearchFn={isTextSearchFn}
                          getChildValuesFn={getChildValuesFn}
                          useLargerCheckbox={this.props.useLargerCheckbox}
                        />
                      )
                  })}
                </ChildBranches>
              )}
          </div>
        </Branch>
      )
    }
  }
}

Tree.propTypes = {
  useLargerCheckbox: PropTypes.bool
}

Tree.defaultProps = {
  useLargerCheckbox: false
}

export default Tree



// WEBPACK FOOTER //
// ./src/components/layout/checkbox-tree/Tree.jsx